import { computed } from 'vue'

import { useUserStore } from './useUserStore'

export const useStaffPermissions = () => {
  const { user, isUserAuthenticatedStaff } = useUserStore()

  // avoid using this, use a specific permission getter instead
  const permissions = computed(() => {
    return user.value.permissions
  })

  const isUserAuthenticatedDexAgent = computed(() => {
    return permissions.value.includes('group-dex-bpo-agents')
  })

  const isUserAuthenticatedFraudLogisticsAgent = computed(() => {
    return permissions.value.includes('group-fraud-logistics-bpo-agents')
  })

  const isUserCareBpo = computed(() => {
    return (
      permissions.value.includes('group-care-bpo-agents') ||
      permissions.value.includes('group-care-bpo-agents-plus') ||
      permissions.value.includes('group-care-bpo-supervisors')
    )
  })

  const canViewCustomers = computed(() => {
    return (
      permissions.value.includes('view-customers') ||
      isUserAuthenticatedStaff.value
    )
  })

  const canAccessCustomerLifecyle = computed(() => {
    return permissions.value.includes('group-customer-lifecycle-managers')
  })

  const canBlockCustomers = computed(() => {
    return permissions.value.includes('group-can-block-customers')
  })

  const canImpersonateSeller = computed(() => {
    return permissions.value.includes('permission-impersonate-sellers')
  })

  const canAccessGdpr = computed(() => {
    return permissions.value.includes('group-identity-gdpr-access')
  })

  const canBulkResetPassword = computed(() => {
    return permissions.value.includes('group-users-security-managers')
  })

  const canViewPromotionCodes = computed(() =>
    permissions.value.includes('group-view-promotion-codes'),
  )

  const canCreatePromotionCodes = computed(() =>
    permissions.value.includes('group-create-promotion-codes'),
  )

  const canAdminPromotionCodes = computed(() =>
    permissions.value.includes('group-admin-promotion-codes'),
  )

  const canViewPromocodes = computed(() =>
    permissions.value.includes('permission-view-promo-codes'),
  )

  const canCreatePromocodes = computed(() =>
    permissions.value.includes('permission-create-promo-codes'),
  )

  const canValidatePromocodes = computed(() =>
    permissions.value.includes('permission-validate-promo-codes'),
  )

  const canExportPromocodes = computed(() =>
    permissions.value.includes('permission-export-promo-codes'),
  )

  const canManagePromocodeCategories = computed(() =>
    permissions.value.includes('permission-manage-promo-code-category'),
  )

  const canManageFinanceExpenses = computed(() =>
    permissions.value.includes('permission-manage-finance-expense'),
  )

  const canViewPromocodeAuditLog = computed(() =>
    permissions.value.includes('permission-view-promo-code-audit-log'),
  )

  const canAccessPiiArchives = computed(() => {
    return permissions.value.includes('group-pii-archive')
  })

  const canAccessSupportArchive = computed(() => {
    return permissions.value.includes('permission-view-care-archive')
  })

  const canManageCareTemplates = computed(() => {
    return permissions.value.includes('group-care-template-management')
  })

  const canViewUsers = computed(() => {
    return permissions.value.includes('group-view-users')
  })

  const canDisableUser2fa = computed(() => {
    return permissions.value.includes('permission-disable-users-2fa')
  })

  const canManageLegalOptout = computed(() => {
    return permissions.value.includes('group-manage-legal-optout')
  })

  const canAccessCmsContent = computed(() => {
    return permissions.value.includes('group-customer-content-admin-read')
  })

  const canViewProductDetailConfigurator = computed(() => {
    return permissions.value.includes('group-bo-staff-product')
  })

  const canLogPhoneCalls = computed(() => {
    return permissions.value.includes('permission-log-phone-calls')
  })

  const canCreateHelpRequestContacts = computed(() => {
    return permissions.value.includes('permission-create-help-request-contacts')
  })

  const canAccessCreditRequests = computed(() => {
    return (
      permissions.value.includes('group-credit-request-super-users') ||
      permissions.value.includes('group-credit-request-validators') ||
      permissions.value.includes('manage-credit-requests')
    )
  })

  const canManageSmartcoRules = computed(() => {
    return permissions.value.includes('group-sales-commission-smartco')
  })

  const canManageOAuth2Clients = computed(() => {
    return permissions.value.includes('group-oauth2-clients-managers')
  })

  const isUserOktaAuthenticated = computed(() => {
    return !!user.value.bmUserId && permissions.value.length > 0
  })

  return {
    permissions,
    isUserAuthenticatedDexAgent,
    isUserAuthenticatedFraudLogisticsAgent,
    isUserCareBpo,
    canViewCustomers,
    canAccessCustomerLifecyle,
    canBlockCustomers,
    canImpersonateSeller,
    canAccessGdpr,
    canBulkResetPassword,
    canViewPromotionCodes,
    canCreatePromotionCodes,
    canAdminPromotionCodes,
    canViewPromocodes,
    canCreatePromocodes,
    canValidatePromocodes,
    canExportPromocodes,
    canManagePromocodeCategories,
    canManageFinanceExpenses,
    canViewPromocodeAuditLog,
    canAccessPiiArchives,
    canAccessSupportArchive,
    canManageCareTemplates,
    canLogPhoneCalls,
    canViewUsers,
    canDisableUser2fa,
    canManageLegalOptout,
    canAccessCmsContent,
    canViewProductDetailConfigurator,
    canCreateHelpRequestContacts,
    canAccessCreditRequests,
    canManageSmartcoRules,
    canManageOAuth2Clients,
    isUserOktaAuthenticated,
  }
}
